import VideoElement from '../VideoElement/VideoElement';
import MobileVideoElementDefinition from './MobileVideoElementDefinition';
import MobileVideoElementMetaData from './MobileVideoElementMetaData';

export default {
  MobileVideoElement: VideoElement,
  MobileVideoElementDefinition: MobileVideoElementDefinition,
  MobileVideoElementType: MobileVideoElementMetaData.type
};
